import React from "react";


import BasePageView from "views/BasePageView.js";

import AboutUs from "components/AboutUs.js";


function NosotrosView() {
  
  return (
      <BasePageView>        
      <div className="wrapper">
        <AboutUs />
        {/*<div className="wrapper-empty"></div>*/}
      </div>
      </BasePageView>
  );
}

export default NosotrosView;
